import { render, staticRenderFns } from "./SiteHealthView.vue?vue&type=template&id=7680cbe0&scoped=true"
import script from "./SiteHealthView.vue?vue&type=script&lang=js"
export * from "./SiteHealthView.vue?vue&type=script&lang=js"
import style0 from "./SiteHealthView.vue?vue&type=style&index=0&id=7680cbe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680cbe0",
  null
  
)

export default component.exports